import { MAX_INTEGER } from "@/constants/common";
import { USER_ACTIVE_STATUS } from "@/types/enum";
import { validator } from "@/utils/validator";

export const companyUserSchema = validator.object().shape({
  fullName: validator.string().trim().emptyToNull().label("氏名").required(),
  email: validator.string().trim().emptyToNull().email().max(60).label("メールアドレス").required(),
  isCompanyUser: validator.number().isSelection().emptyToNull().limit(MAX_INTEGER).label("所属").required(),
  activeStatus: validator
    .string()
    .trim()
    .isSelection()
    .emptyToNull()
    .label("ステータス")
    .notRequired()
    .test((value, ctx) => {
      const isCompanyAdmin = ctx.parent.isCompanyAdmin;
      if (isCompanyAdmin === 1 && value === USER_ACTIVE_STATUS.INACTIVE) {
        return ctx.createError({
          message: "現在管理者として設定されているため、停止中に変更できません。",
        });
      }
      return true;
    }),
});
